import React, { useState } from 'react'
import { ITransportationOrderDetail } from '../../../../../../modules/API/Seller/models/transportation'
import styled from 'styled-components'
import RowInput from '../../../../../../generic/inputs/RowInput'
import PalletIcon from '../../../../../../generic/icons/IconLib/PalletIcon'
import ShekelIcon from '../../../../../../generic/icons/IconLib/ShekelIcon'
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon'
import TitleRowItem from '../../../kosherTeudot/generic/TitleRowItem'

interface INestedItemProps {
  title: string,
  palletQty?: number,
  defaultPrice?: number[], // TODO: defaultPrice array of [min, max]
  index: number,
  item: ITransportationOrderDetail,
  handleChangePrice?: (price: number[], item: ITransportationOrderDetail) => void
}

const NestedItem = (props: INestedItemProps) => {
  const { 
    title, 
    palletQty, 
    defaultPrice,
    index,
    item,
    handleChangePrice
  } = props;
  const [priceFrom, setPriceFrom] = useState<number>(defaultPrice?.[0] || 0)
  const [priceTo, setPriceTo] = useState<number>(defaultPrice?.[1] || 0)
  const handlePriceFrom = (price: React.ChangeEvent<HTMLInputElement>) => {
    if(isNaN(Number(price.target.value)) || !handleChangePrice) return
    setPriceFrom(Number(price.target.value))
    handleChangePrice([Number(price.target.value), priceTo], item)
  }
  const handlePriceTo = (price: React.ChangeEvent<HTMLInputElement>) => {
    if(isNaN(Number(price.target.value)) || !handleChangePrice) return
    setPriceTo(Number(price.target.value))
    handleChangePrice([priceFrom, Number(price.target.value)], item)
  }
 

  return (
    <MainWrapper>
      <TitleRow $isOdd={index % 2 === 0}>
        <TitleRowItem
          name={title}
          icon={<UserIcon />}
        />
        {palletQty &&
          <TitleRowItem
            name={`${palletQty}`}
            icon={<PalletIcon />}
          />
        }
    
      
      </TitleRow>
      <TitleRow $isOdd={index % 2 === 0}>
      {handleChangePrice &&
      <>
        <RowInput
          defValue={priceFrom} // TODO: price_min
          handleInput={handlePriceFrom}
          icon={<ShekelIcon />} 
          isDisabled={false}
        />
        -
        <RowInput
          defValue={priceTo} // TODO: price_max
          handleInput={handlePriceTo}
          icon={<ShekelIcon />}
          isDisabled={false}
        />
      </>
      }
      </TitleRow>
    </MainWrapper>
  )
}

const MainWrapper = styled.div`
  display: flex;
  flex-flow: column;
`

const TitleRow = styled.div<{$isOdd: boolean}>`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row-reverse;
  gap: 1em;
  padding: 0.2em;
  border-radius: 5px;
  background-color: ${props => props.$isOdd ? '#f0f0f0' : '#fff'};
`


export default NestedItem